import React from 'react';
import Line01 from '../../../assets/images/line01.png';
import Line02 from '../../../assets/images/line02.png';
import Line03 from '../../../assets/images/line03.png';
import Line04 from '../../../assets/images/line04.png';
import Line05 from '../../../assets/images/line05.png';

export const LineImages = () => {
  return (
    <g>
      <image x={5} y={120} xlinkHref={Line01}></image>
      <image x={100} y={120} xlinkHref={Line03}></image>
      <image x={195} y={120} xlinkHref={Line04}></image>
      <image x={290} y={120} xlinkHref={Line05}></image>
      <image x={385} y={120} xlinkHref={Line02}></image>
    </g>
  );
};
